import { HeroStatsProps } from "./types";
import Default from "./variants/Default";
import DarkLogo from "./variants/DarkLogo";
import DarkLogoNoGap from "./variants/DarkLogoNoGap";
import LightLogo from "./variants/LightLogo";

export default function HeroStats({ variant, ...props }: HeroStatsProps) {
  switch (variant) {
    case "dark-logo":
      return <DarkLogo {...props} />;
    case "dark-logo-nogap":
      return <DarkLogoNoGap {...props} />;
    case "light-logo":
      return <LightLogo {...props} />;
    default:
      return <Default {...props} />;
  }
}
